
export const stars = [1, 2, 3, 4, 5, 6, 7];

export const gear = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];

export const gearSub6Stars = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

export const relic = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]